import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginAsAdminQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LoginAsAdminQuery = { __typename?: 'Query', loginAsAdmin: { __typename?: 'AuthResponse', token: string, authTokenType: Types.AuthTokenType, user: { __typename?: 'AuthResponseUser', id: string, companyName?: string | null, authUserType: Types.AccountType, firstName?: string | null, lastName?: string | null }, shopLocation?: { __typename?: 'AuthResponseLocation', id: string, name: string } | null } };

export type LoginAsShopQueryVariables = Types.Exact<{
  input: Types.LoginAsShopInput;
}>;


export type LoginAsShopQuery = { __typename?: 'Query', loginAsShop: { __typename?: 'AuthResponse', token: string, authTokenType: Types.AuthTokenType, user: { __typename?: 'AuthResponseUser', id: string, companyName?: string | null, authUserType: Types.AccountType }, shopLocation?: { __typename?: 'AuthResponseLocation', id: string, name: string } | null } };


export const LoginAsAdminDocument = gql`
    query LoginAsAdmin {
  loginAsAdmin {
    user {
      id
      companyName
      authUserType
      firstName
      lastName
    }
    token
    authTokenType
    shopLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useLoginAsAdminQuery__
 *
 * To run a query within a React component, call `useLoginAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<LoginAsAdminQuery, LoginAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsAdminQuery, LoginAsAdminQueryVariables>(LoginAsAdminDocument, options);
      }
export function useLoginAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsAdminQuery, LoginAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsAdminQuery, LoginAsAdminQueryVariables>(LoginAsAdminDocument, options);
        }
export function useLoginAsAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsAdminQuery, LoginAsAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginAsAdminQuery, LoginAsAdminQueryVariables>(LoginAsAdminDocument, options);
        }
export type LoginAsAdminQueryHookResult = ReturnType<typeof useLoginAsAdminQuery>;
export type LoginAsAdminLazyQueryHookResult = ReturnType<typeof useLoginAsAdminLazyQuery>;
export type LoginAsAdminSuspenseQueryHookResult = ReturnType<typeof useLoginAsAdminSuspenseQuery>;
export type LoginAsAdminQueryResult = Apollo.QueryResult<LoginAsAdminQuery, LoginAsAdminQueryVariables>;
export const LoginAsShopDocument = gql`
    query LoginAsShop($input: LoginAsShopInput!) {
  loginAsShop(input: $input) {
    user {
      id
      companyName
      authUserType
    }
    token
    authTokenType
    shopLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useLoginAsShopQuery__
 *
 * To run a query within a React component, call `useLoginAsShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsShopQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginAsShopQuery(baseOptions: Apollo.QueryHookOptions<LoginAsShopQuery, LoginAsShopQueryVariables> & ({ variables: LoginAsShopQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsShopQuery, LoginAsShopQueryVariables>(LoginAsShopDocument, options);
      }
export function useLoginAsShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsShopQuery, LoginAsShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsShopQuery, LoginAsShopQueryVariables>(LoginAsShopDocument, options);
        }
export function useLoginAsShopSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsShopQuery, LoginAsShopQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginAsShopQuery, LoginAsShopQueryVariables>(LoginAsShopDocument, options);
        }
export type LoginAsShopQueryHookResult = ReturnType<typeof useLoginAsShopQuery>;
export type LoginAsShopLazyQueryHookResult = ReturnType<typeof useLoginAsShopLazyQuery>;
export type LoginAsShopSuspenseQueryHookResult = ReturnType<typeof useLoginAsShopSuspenseQuery>;
export type LoginAsShopQueryResult = Apollo.QueryResult<LoginAsShopQuery, LoginAsShopQueryVariables>;